module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-0.04797c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-0.png
// module id = 188
// module chunks = 0